// extracted by mini-css-extract-plugin
export var staffGradient = "staffStyles-module--staff-gradient--3R_jy";